import { MutableRefObject, useEffect, useState } from 'react';

type Args = {
  containerRef: MutableRefObject<Element | null>;
  columnGap: number;
  columnWidth: number;
};
/**
 * based on https://stackoverflow.com/a/55243400
 */
const useCalculateGridColumns = ({
  containerRef,
  columnGap,
  columnWidth,
}: Args) => {
  const [columnsLength, setColumnsLength] = useState(0);

  useEffect(() => {
    if (containerRef.current) {
      const calculateColumns = () => {
        const width = containerRef.current?.getBoundingClientRect().width || 0;

        setColumnsLength(
          Math.floor((width + columnGap) / (columnWidth + columnGap)),
        );
      };

      const resizeObserver = new ResizeObserver(calculateColumns);
      resizeObserver.observe(containerRef.current);

      return () => {
        resizeObserver.disconnect();
      };
    }
  }, [columnGap, columnWidth, containerRef]);

  return {
    columnsLength,
    columnGap,
    columnWidth,
  };
};

export default useCalculateGridColumns;
